<!--
 * @Author:
 * @Description:
 * @Date: 2025-04-09 19:21:21
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/risk/components/add-blackList-item/single.vue
-->
<template>
  <div class="add-black-list-item-single">
    <validate-component ref="AddBlackListItemSingle" :validation-condition="validationCondition">
      <template #noExpiration>
        <el-checkbox v-model="noExpiration">{{ $t('message.risk.noExpiration') }}</el-checkbox>
      </template>

    </validate-component>
  </div>
</template>
<script>

import { REQUIRED } from '@/components/validation/tool/validator';
import ValidateComponent from '@/components/validation/validation.vue';

export default {
  name: 'AddBlackListItemSingle',
  props: {
    libInfo: {
      type: Object,
      default: () => ({
        type: 'CARD_NUMBER_HASH',
      }),
    },
  },
  data() {
    return {
      noExpiration: true,
      exampleList: [
        {
          example: '@spam.com\n@blacklist.com',
          type: 'EMAIL_DOMAIN',
        },
        {
          example: '3765770000889955\n4596320000123456',
          type: 'CARD_NUMBER_HASH',
        },
        {
          example: '19YYYY8786\n16YYYY9879',
          type: 'PHONE',
        },
        {
          example: 'Fake35@aaa.com\nTest12@bbb.com',
          type: 'EMAIL',
        },
        {
          example: '192.88.12.102\nFC00:0000:130F:0000:0000:09C0:876A:130B',
          type: 'IP',
        },
      ],
      disabledSelectDate: true,
      example: '@spam.com\n@blacklist.com',
      validationCondition: [
        {
          key: 'addOneType',
          placeholder: 'message.risk.searchByTransactionId',
          type: 'checkbox',
          defValue: false,
          isShowStar: true,
          rule: [],
          onChange: (value) => {
            if (!value) {
              this.updateExample();
            } else {
              this.example = 'TX202408250001\nTX202408250002';
            }
            // Update the example in validationCondition
            const valuesItem = this.validationCondition.find(item => item.key === 'values');
            if (valuesItem) {
              valuesItem.example = this.example;
              this.$forceUpdate();
            }
          },
        },
        {
          key: 'values',
          name: 'message.risk.itemsData',
          type: 'textarea',
          defValue: '',
          isShowStar: true,
          placeholder: 'message.risk.addBlackListItem.itemsDataPlaceholder.enterDataOnePerLine',
          isInternationalization: true,
          rule: [REQUIRED],
          rows: 4,
          example: '@spam.com\n@blacklist.com',
          // tipList: [
          //   {
          //     value: this.$t('message.risk.itemsDataTips'),
          //   },
          // ],
        },
        {
          key: 'status',
          name: '',
          type: 'radio',
          defValue: '0',
          isShowStar: true,
          rule: [REQUIRED],
          isInternationalization: true,
          options: [
            {
              value: '0',
              label: 'message.common.enable',
            },
            {
              value: '1',
              label: 'message.common.disable',
            },
          ],
        },
        {
          key: 'expirationTime',
          name: 'message.risk.expireDate',
          type: 'date_time',
          defValue: '',
          placeholder: 'YYYY-MM-DD',
          isShowStar: true,
          useWrapperClass: true,
          dateType: 'date',
          rule: [],
          isDisabled: () => this.disabledSelectDate,
          dateFormat: 'yyyy-MM-dd',
          dateValueFormat: 'yyyy-MM-dd HH:mm:ss',
          datePickerTips: this.$t('message.risk.addBlackListItem.expireDateTips'),
          // tipList: [
          //   {
          //     value: this.$t('message.risk.expireDateTips'),
          //   },
          // ],
        },
      ],
    };
  },
  components: {
    ValidateComponent,
  },
  mounted() {
    this.updateExample();
  },
  methods: {
    updateExample() {
      const { type } = this.libInfo;
      if (type) {
        const matchedExample = this.exampleList.find(item => item.type === type);
        if (matchedExample) {
          this.example = matchedExample.example;
          const valuesItem = this.validationCondition.find(item => item.key === 'values');
          if (valuesItem) {
            valuesItem.example = this.example;
            // Force update to ensure the view is refreshed
            this.$forceUpdate();
          }
        }
      }
    },
    toFormValid(validCallBack, errorCallBack) {
      return new Promise((resolve, reject) => {
        this.$refs.AddBlackListItemSingle.toFormValid(
          (formData) => {
            if (validCallBack) validCallBack(formData);
            resolve({ valid: true, formData });
          },
          (formData) => {
            if (errorCallBack) errorCallBack(formData);
            resolve({ valid: false, formData });
          },
        )();
      });
    },

  },
  watch: {
    noExpiration(newVal) {
      this.disabledSelectDate = newVal;
      if (newVal) {
        this.$refs.AddBlackListItemSingle.validationForm.expirationTime = '';
      }
      // Find the expirationTime item and update its disabled state
      const expirationTimeItem = this.validationCondition.find(item => item.key === 'expirationTime');
      if (expirationTimeItem) {
        expirationTimeItem.isDisabled = newVal;
      }
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss" scoped>
.add-black-list-item-single {
  margin-top: 24px;
}
</style>
